import { render, staticRenderFns } from "./SubKategoriSOSPopup.vue?vue&type=template&id=6d848eb8&scoped=true"
import script from "./SubKategoriSOSPopup.vue?vue&type=script&lang=js"
export * from "./SubKategoriSOSPopup.vue?vue&type=script&lang=js"
import style0 from "./SubKategoriSOSPopup.vue?vue&type=style&index=0&id=6d848eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d848eb8",
  null
  
)

export default component.exports